(function () {
  "use strict";

  if (window.QalbiProductPageLoaded) {
    return;
  }

  window.QalbiProductPageLoaded = true;

  /**
   * Returns an offset so opened accordions are not hidden
   * beneath a sticky theme header.
   */
  function getScrollOffset() {
    var possibleHeaders = [
      document.querySelector(".shopify-section-header-sticky"),
      document.querySelector(".sticky-header"),
      document.querySelector("#shopify-section-header"),
      document.querySelector("header")
    ];

    var offset = 20;

    possibleHeaders.forEach(function (header) {
      if (!header) {
        return;
      }

      var styles = window.getComputedStyle(header);
      var rect = header.getBoundingClientRect();

      if (
        styles.display !== "none" &&
        styles.visibility !== "hidden" &&
        rect.height > 0
      ) {
        offset = Math.max(offset, rect.height + 20);
      }
    });

    return offset;
  }

  var QALBI_PANEL_DURATION = 380;
  var QALBI_PANEL_EASING = "cubic-bezier(0.32, 0.72, 0, 1)";

  function prefersReducedMotion() {
    return Boolean(
      window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  /**
   * Gives a <details> panel a smooth open and close.
   *
   * A native <details> snaps because the browser has nothing to
   * interpolate between: the content is either in the layout or
   * it is not. So the click is intercepted, the element is held
   * open, and its own height is animated from the summary height
   * to the full height. The open attribute is only committed when
   * the animation finishes, which keeps the element valid the
   * whole way through -- find in page, anchor links and screen
   * readers all still see a normal details element.
   *
   * Web Animations are used rather than a CSS transition because
   * height:auto is not interpolatable, and the panel height is
   * not known until it is measured.
   */
  function animateDetails(details) {
    if (!details || details.dataset.qalbiAnimated === "true") {
      return;
    }

    var summary = details.querySelector("summary");
    var content = summary && summary.nextElementSibling;

    /*
     * No Web Animations support, or an unexpected shape:
     * leave the element alone and let it behave natively.
     */
    if (
      !summary ||
      !content ||
      typeof details.animate !== "function"
    ) {
      return;
    }

    details.dataset.qalbiAnimated = "true";

    var animation = null;
    var isClosing = false;
    var isExpanding = false;

    function settle(isOpen) {
      details.open = isOpen;
      animation = null;
      isClosing = false;
      isExpanding = false;
      details.style.height = "";
      details.style.overflow = "";
    }

    function animateTo(startHeight, endHeight, isOpen) {
      if (animation) {
        animation.cancel();
      }

      details.style.overflow = "hidden";

      animation = details.animate(
        {
          height: [startHeight + "px", endHeight + "px"]
        },
        {
          duration: QALBI_PANEL_DURATION,
          easing: QALBI_PANEL_EASING
        }
      );

      animation.onfinish = function () {
        settle(isOpen);
      };

      animation.oncancel = function () {
        isClosing = false;
        isExpanding = false;
      };
    }

    function shrink() {
      isClosing = true;

      animateTo(
        details.offsetHeight,
        summary.offsetHeight,
        false
      );
    }

    function expand() {
      isExpanding = true;

      animateTo(
        details.offsetHeight,
        summary.offsetHeight + content.offsetHeight,
        true
      );
    }

    function open() {
      if (prefersReducedMotion()) {
        details.open = true;
        return;
      }

      /*
       * Pin the collapsed height first, then open. Without the
       * pin the browser paints the full panel for one frame
       * before the animation starts, which is the flash this is
       * meant to remove.
       */
      details.style.height = details.offsetHeight + "px";
      details.open = true;

      window.requestAnimationFrame(expand);
    }

    /* Read more and Size Guide links reuse this. */
    details.qalbiOpenPanel = open;

    summary.addEventListener("click", function (event) {
      if (prefersReducedMotion()) {
        return;
      }

      event.preventDefault();

      if (isClosing || !details.open) {
        open();
      } else if (isExpanding || details.open) {
        shrink();
      }
    });
  }

  function initialiseAccordionAnimation(root) {
    root
      .querySelectorAll(
        "details.qalbi-accordion-item, details.qalbi-size-guide"
      )
      .forEach(animateDetails);
  }

  /**
   * Opens a details element and jumps directly to it.
   *
   * An instant jump is used instead of smooth scrolling because
   * the desktop image gallery also reacts to page scrolling.
   */
  function openAndScrollToDetails(detailsElement) {
    if (!detailsElement) {
      return;
    }

    var wasClosed = !detailsElement.open;
    var animates =
      typeof detailsElement.qalbiOpenPanel === "function" &&
      !prefersReducedMotion();

    if (wasClosed) {
      if (animates) {
        detailsElement.qalbiOpenPanel();
      } else {
        detailsElement.open = true;
      }
    }

    /*
     * Wait for the browser to calculate the newly opened
     * accordion height before calculating its page position.
     * When the panel animates, wait for it to land as well --
     * measuring mid-animation scrolls to a height the panel is
     * no longer at by the time the scroll finishes.
     */
    window.setTimeout(function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          var targetTop =
            detailsElement.getBoundingClientRect().top +
            window.pageYOffset -
            getScrollOffset();

          window.scrollTo(0, Math.max(targetTop, 0));

          var summary = detailsElement.querySelector("summary");

          if (summary) {
            window.setTimeout(function () {
              try {
                summary.focus({
                  preventScroll: true
                });
              } catch (error) {
                summary.focus();
              }
            }, 0);
          }
        });
      });
    }, wasClosed && animates ? QALBI_PANEL_DURATION : 0);
  }

  /**
   * Connects Read more and Size Guide links to their
   * corresponding details elements.
   */
  function initialiseDisclosureLinks(root) {
    root
      .querySelectorAll("[data-qalbi-read-more]")
      .forEach(function (link) {
        var targetId = link.getAttribute("aria-controls");
        var description = targetId
          ? document.getElementById(targetId)
          : root.querySelector("[data-qalbi-description]");

        if (!description) {
          link.hidden = true;
          return;
        }

        if (!targetId && description.id) {
          link.setAttribute(
            "aria-controls",
            description.id
          );
        }

        /*
         * Capture mode and stopImmediatePropagation prevent
         * older theme click handlers from treating this link
         * as a gallery or generic product action.
         */
        link.addEventListener(
          "click",
          function (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            openAndScrollToDetails(description);
          },
          true
        );
      });

    root
      .querySelectorAll("[data-qalbi-size-guide-trigger]")
      .forEach(function (link) {
        var targetId = link.getAttribute("aria-controls");
        var sizeGuide = targetId
          ? document.getElementById(targetId)
          : root.querySelector("[data-qalbi-size-guide]");

        if (!sizeGuide) {
          link.hidden = true;
          return;
        }

        if (!targetId && sizeGuide.id) {
          link.setAttribute(
            "aria-controls",
            sizeGuide.id
          );
        }

        link.addEventListener(
          "click",
          function (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            openAndScrollToDetails(sizeGuide);
          },
          true
        );
      });
  }

  function initProduct(root) {
    if (
      !root ||
      root.dataset.qalbiInitialized === "true"
    ) {
      return;
    }

    root.dataset.qalbiInitialized = "true";

    initialiseDisclosureLinks(root);
    initialiseAccordionAnimation(root);

    var sectionId = root.getAttribute("data-section-id");

    var productJsonElement = document.getElementById(
      "ProductJson-" + sectionId
    );

    var variantSelect = root.querySelector(
      ".product-form__variants"
    );

    var stockStatus = root.querySelector(
      "[data-qalbi-stock-status]"
    );

    var stockText = root.querySelector(
      "[data-qalbi-stock-text]"
    );

    /*
     * Disclosure links can still work even when the product
     * JSON or stock components are absent.
     */
    if (
      !productJsonElement ||
      !variantSelect ||
      !stockStatus ||
      !stockText
    ) {
      return;
    }

    var productData;

    try {
      productData = JSON.parse(
        productJsonElement.textContent
      );
    } catch (error) {
      console.error(
        "Qalbi product JSON could not be read.",
        error
      );

      return;
    }

    function getSelectedVariant() {
      var selectedId = String(variantSelect.value);

      return productData.variants.find(
        function (variant) {
          return String(variant.id) === selectedId;
        }
      );
    }

    function updateStockStatus() {
      var selectedVariant = getSelectedVariant();

      if (!selectedVariant) {
        stockStatus.classList.add(
          "is-out-of-stock"
        );

        stockText.textContent = "Unavailable";
        return;
      }

      if (selectedVariant.available) {
        stockStatus.classList.remove(
          "is-out-of-stock"
        );

        stockText.textContent = "In stock";
      } else {
        stockStatus.classList.add(
          "is-out-of-stock"
        );

        stockText.textContent = "Out of stock";
      }
    }

    function queueStockUpdate() {
      window.setTimeout(updateStockStatus, 60);
    }

    root.addEventListener(
      "change",
      function (event) {
        if (
          event.target.matches(
            ".single-option-selector, " +
              ".swatch input, " +
              ".product-form__variants"
          )
        ) {
          queueStockUpdate();
        }
      }
    );

    var addToCartButton = root.querySelector(
      ".dT_AddToCart"
    );

    if (
      addToCartButton &&
      "MutationObserver" in window
    ) {
      var buttonObserver = new MutationObserver(
        queueStockUpdate
      );

      buttonObserver.observe(addToCartButton, {
        attributes: true,
        attributeFilter: ["disabled"]
      });
    }

    updateStockStatus();
  }

  function initProducts(scope) {
    var parent = scope || document;

    parent
      .querySelectorAll("[data-qalbi-product-root]")
      .forEach(initProduct);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        initProducts(document);
      }
    );
  } else {
    initProducts(document);
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initProducts(event.target);
    }
  );
})();